












































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import '@/compiled-icons/format-align-center';
import '@/compiled-icons/format-align-left';
import '@/compiled-icons/format-align-right';
import '@/compiled-icons/toy-brick-plus-outline';

import '@/compiled-icons/add';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';

@Component({
  name: 'dynamic-document-working-area-boundary-field-template',
  components: {
    AmetrasTextAreaFieldTemplate,
    AmetrasTextFieldTemplate
  }
})
export default class DynamicDocumentMachineWorkingAreaBoundaryFieldTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldTypeYearMonthDtoV2 | undefined;

}
